/************
 * Model Class
 * File Name ...: renderer-helper.components.ts
 * Generated By : ianday on 2/8/24
 * Date ........: 2/8/24
 /************/
import {DwUtils} from "../../../components/utils/dw-utils";


export class RendererHelper {

    public startDate: string;
    public endDate: string;
    public prevStartDate: string;
    public prevEndDate: string;

    constructor() {

    }
    public calculateDatePair(interval: number): void {

        const today: Date = new Date();

        /** Today **/
        if(interval === 1) {
            const prevDate = new Date();
            prevDate.setDate(today.getDate()-1);

            this.setDates(today, today, prevDate, prevDate);
        }
        /** this week (starting monday) **/
        if(interval === 7) {
            let prevMonday = new Date();
            prevMonday.setDate(prevMonday.getDate() - (prevMonday.getDay() + 6) % 7);

            let endWeek = new Date();
            endWeek.setDate(prevMonday.getDate()+6);

            let prevPrevMonday = new Date();
            prevPrevMonday.setDate(prevMonday.getDate() -7);

            let prevEndOfWeek = new Date(prevPrevMonday);
            prevEndOfWeek.setDate(prevPrevMonday.getDate() +6);


            this.setDates(prevMonday, endWeek, prevPrevMonday, prevEndOfWeek);
        }
        /** this month (starting on the fist of the month) **/
        if(interval === 30) {
            let date = new Date();
            let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
            let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

            let prevFirstDay = new Date(firstDay.getFullYear(), (firstDay.getMonth()-1), 1);
            let prevLastDay = new Date(lastDay.getFullYear(), (lastDay.getMonth() ), 0);

            this.setDates(firstDay, lastDay, prevFirstDay, prevLastDay);
        }

        /** last 6 months  **/
        if(interval === 1040) {
            let date = new Date();
            let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
            let firstDaySixMonthsAgo = new Date(firstDay.getFullYear(), (firstDay.getMonth() -5), 1);
            let lastDay = new Date();

            let prevFirstDay = new Date();
            prevFirstDay = new Date(firstDaySixMonthsAgo.getFullYear(), (firstDaySixMonthsAgo.getMonth() -6), 1);

            let prevLastDay = new Date();
            prevLastDay = new Date(firstDaySixMonthsAgo.setDate(firstDaySixMonthsAgo.getDate() -1));

            this.setDates(firstDaySixMonthsAgo, lastDay, prevFirstDay, prevLastDay);
        }
    }
    public setDates(start: Date, end: Date, prevStart: Date, prevEnd: Date): void {

        this.startDate = DwUtils.formatDTFromDate(start, true) + "T00:01";
        this.endDate = DwUtils.formatDTFromDate(end, true)+ "T23:59";

        this.prevStartDate = DwUtils.formatDTFromDate(prevStart, true) + "T00:01";
        this.prevEndDate = DwUtils.formatDTFromDate(prevEnd, true)+ "T23:59";
    }
}
